/* @flow */
/* eslint import/prefer-default-export: 0 */

import * as promotionApi from '../api/promotion';
import * as types from '../constants/actionTypes';
import { SUBMIT_SUPEROVER_SCORE } from '../constants/apiTypes';

export function submitSuperoverScore(data: { token: string }) {
  return {
    type: types.API_CALL,
    api: SUBMIT_SUPEROVER_SCORE,
    request: promotionApi.submitSuperoverScore(data)
  };
}
